import { useNavigate } from "react-router-dom";
import { GroupForm } from "./GroupForm";

export function CreateGroups() {
  const navigate = useNavigate();

  const handleCreate = (groupData) => {
    console.log("Creating group:", groupData);
    // Send groupData to backend here
    navigate("/groups");
  };

  return (
    <GroupForm
      onSubmit={handleCreate}
      onCancel={() => navigate("/groups")}
    />
  );
}
